<template lang="pug">
md-layout(md-flex='100')
	md-layout(md-flex='90', md-flex-offset='5')
		md-card.md-table-card.content-table
			md-card-header.md-title
				| Billing report
			form.search-form(novalidate, @submit.stop.prevent='searchForBilling')
				md-layout(:md-gutter='24')
					md-layout(md-flex='20', md-flex-small='30')
						md-input-container
							label(for='criteria') Month
							md-select#criteria(v-model='filters.month', @selected='searchForBilling' )
								md-option(:value="month.value" v-for='month in months' :key="month.value") {{ month.name }}
					md-layout(md-flex='20', md-flex-small='30')
						md-input-container
							label(for='criteria') Year
							md-select#criteria(v-model='filters.year', @selected='searchForBilling' )
								md-option(:value="year.value" v-for='year in years' :key="year.value") {{ year.value }}
					md-layout(md-flex='10', md-flex-small='10', md-flex-xsmall='100', md-vertical-align='center', md-align-xsmall='center')
						md-button.search-btn.md-raised.md-icon-button.btn(type='submit', :disabled='loading || $v.$invalid')
							md-icon.icon(md-iconset="fa fa-search")

			stitch-loader(:loading='loading', :size='45')
				div.table()
					div.accountContainer.colorHover(v-for='(data, idx) in bill' :key="idx")
						div.titleName {{  data.account.name}}
						div.titleLine.styleRow
							p.rowElements Mediaconvert minutes
							p.rowElements Bandwidth GB
							p.rowElements Bandwidth count
							p.rowElements(v-if="data.billingStorage !== undefined") Storage
							p.rowElements TOTAL
						div.styleRow
							div.rowElements
								div.info
									div
										p HD
										sub.description Minutes: {{ data.billingTranscode.mediaConvert.hdMinutesTranscoded.toFixed(2) }}
										sub.description Price: $0.015
										br
										sub.description Total: $ {{ mediaConvertHD(idx) }}
									div
										p SD
										sub.description Minutes: {{ data.billingTranscode.mediaConvert.sdMinutesTranscoded.toFixed(2) }}
										sub.description Price: $0.0075
										br
										sub.description Total: $ {{ mediaConvertSD(idx) }}
								div.priceTotal
									p Total: $ {{ mediaConvertTotal(idx) }}

							div.rowElements
								div.info
									div
										p GB consumed
										sub.description  GB: {{ data.billingBandwith.missTotalGB + data.billingBandwith.hitTotalGB }}
										sub.description PriceGB: $ {{ data.billingBandwith.hitAWSPricePerGB }}
										br
										br
								div.priceTotal
									p Total: $ {{ calculateBandwidthTotal(idx).toFixed(2) }}

							div.rowElements
								div.info
									div
										p Requests count
										sub.description Request: {{ mediaRequest(idx) }}
										sub.description Price per 10k: ${{ data.billingBandwith.AWSPricePer10_000Requests }}
										br
										br
								div.priceTotal
									p Total $ {{ totalMediaRequest(idx) }}

							div.rowElements(v-if="data.billingStorage !== undefined")
								div.info
									div
										p Storage
										sub.description ThumbnailGB: {{ data.billingStorage !== undefined  ? data.billingStorage.thumbnailFilesGB.toFixed(2) : '-'}}
										sub.description TranscodedFilesGB: {{ data.billingStorage !== undefined  ? data.billingStorage.transcodedFilesGB.toFixed(2) : '-'}}
										sub.description UploadedFilesGB: {{ data.billingStorage !== undefined  ? data.billingStorage.uploadedFilesGB.toFixed(2) : '-'}}
										sub.description PriceGB: ${{ priceStorageGB }}

								div.priceTotal
									p Total $ {{ totalBillingStorage(idx) }}

							div.rowElements 
								p $ {{ calculateTotal(idx).toFixed(2) }}
								div.editPercentage
									p + {{data.account.addBillingPercentage ? data.account.addBillingPercentage : percentage  }} %
										button.editBtn(@click="editPercentage(data.account._id)")
											md-icon.editIcon(md-iconset="fa fa-pencil-alt")
								div.priceTotal.priceFinal
									p.totalFinal Total: $ {{ totalReceivable10(idx, data.account.addBillingPercentage ? data.account.addBillingPercentage : percentage) }}
				div#no-results(v-if="noData")
					div.message
						md-icon(md-iconset="fa fa-exclamation-circle",)
						| No items to show
</template>

<script>
import { validationMixin } from "vuelidate";
import reportService from "../../services/reportService";
import stitchLoader from "../../shared-components/Loader";
import accountService from "../../services/accountService";
import { generateMonths, generateYears } from "./dateUtils";

export default {
	mixins: [validationMixin],
	components: {
		stitchLoader,
	},
	data() {
		return {
			months: generateMonths(),
			years: generateYears(),
			accounts: [],
			bill: [],
			priceStorageGB: 0.023,
			loading: false,
			sort: {
				name: "date",
				type: "asc",
			},
			totalEntries: 0,
			currentPagination: {
				size: 50,
				page: 1,
			},
			filters: {
				account: "",
				month: "",
				year: "",
			},
			percentage: 10,
			firstSearch: false,
			arrData: [],
			noData: false
		};
	},
	validations: {},
	computed: {
		searchParams() {
			const params = {
				offset: this.currentPagination.size * (this.currentPagination.page - 1),
				limit: this.currentPagination.size,
			};
			return params;
		},
	},
	methods: {
		editPercentage(accountId) {
			this.$swal.fire({
				title: 'Edit percentage',
				html: '<input type="number" id="swal-input1" class="swal2-input">',
				showCancelButton: true,
				confirmButtonText: 'Confirm',
				cancelButtonText: 'Cancel',
			}).then((res) => {
				if (res.isConfirmed) {
					const value = document.getElementById('swal-input1').value;
					accountService.update(accountId, { addBillingPercentage: value })
						.then(() => {
							this.searchForBilling()
						})
						.catch(() => {
							this.searchForBilling()
						})
				}
			})
		},

		searchForBilling() {
			this.bill = []
			if (
				this.filters.month != "" &&
				this.filters.year != ""
			) {
				this.loading = true;

				reportService
					.getBillingOfAccount(this.filters)
					.then((response) => {
						if (response.data.data.length != 0) {
							this.noData = false
							this.bill = response.data.data

							this.bill = this.bill.reduce((acc, val, idx) => {
								const found = acc.findIndex(obj => obj.account._id === val.account._id)
								if (found >= 0) {
									if (!isNaN(this.calculateTotal(idx)) && this.calculateTotal(acc[found]) < this.calculateTotal(idx)) {
										acc[found] = val
									}
								} else{
									if (this.calculateTotal(idx) > 0) {
										acc.push(val)
									}
								}
								return acc
							}, [])
						} else {
							this.noData = true
						}
						this.loading = false;
					})
					.catch((error) => {
						this.loading = false;
						console.error("Error while retrieving billing report", error);
					});
			}
		},

		//price Bandwidth miss (now the price is the same for miss or hit)
		calculateMiss(idx) {
			if (typeof idx === 'number') {
				return (
					this.bill[idx].billingBandwith.missTotalGB *
					this.bill[idx].billingBandwith.hitAWSPricePerGB
				).toFixed(2)
			} else {
				return (
					idx.billingBandwith.missTotalGB *
					idx.billingBandwith.hitAWSPricePerGB
				).toFixed(2)
			}
		},
		//price Bandwidth hit (now the price is the same for miss or hit)
		calculateHit(idx) {
			if (typeof idx === 'number') {
				return (
					this.bill[idx].billingBandwith.hitTotalGB *
					this.bill[idx].billingBandwith.hitAWSPricePerGB
				).toFixed(2)
			} else {
				return (
					idx.billingBandwith.hitTotalGB *
					idx.billingBandwith.hitAWSPricePerGB
				).toFixed(2)

			}
		},
		//total price Bandwidth
		calculateBandwidthTotal(idx) {
			return (parseFloat(this.calculateMiss(idx)) + parseFloat(this.calculateHit(idx)));
		},
		//total price HD
		mediaConvertHD(idx) {
			if (typeof idx === 'number') {
				const hdMinutes = this.bill[idx].billingTranscode !== undefined ? this.bill[idx].billingTranscode.mediaConvert.hdMinutesTranscoded : 0
				return (hdMinutes * 0.015).toFixed(2)
			} else {
				const hdMinutes = idx.billingTranscode !== undefined ? idx.billingTranscode.mediaConvert.hdMinutesTranscoded : 0
				return (hdMinutes * 0.015).toFixed(2)
			}
		},
		//total price SD
		mediaConvertSD(idx) {
			if (typeof idx === 'number') {
				const sdMinutes = this.bill[idx].billingTranscode !== undefined ? this.bill[idx].billingTranscode.mediaConvert.sdMinutesTranscoded : 0
				return (sdMinutes * 0.0075).toFixed(2)
			} else {
				const sdMinutes = idx.billingTranscode !== undefined ? idx.billingTranscode.mediaConvert.sdMinutesTranscoded : 0
				return (sdMinutes * 0.0075).toFixed(2)
			}
		},
		//total price HD + SD
		mediaConvertTotal(idx) {
			return (parseFloat(this.mediaConvertHD(idx)) + parseFloat(this.mediaConvertSD(idx))).toFixed(2)
		},
		//total request
		mediaRequest(idx) {
			if (typeof idx === 'number') {
				return (this.bill[idx].billingBandwith.missRequestsCount !== undefined ? (this.bill[idx].billingBandwith.missRequestsCount + this.bill[idx].billingBandwith.hitTotalRequestsCount) : '')
			} else {
				return (idx.billingBandwith.missRequestsCount !== undefined ? (idx.billingBandwith.missRequestsCount + idx.billingBandwith.hitTotalRequestsCount) : '')
			}
		},
		//total price request
		totalMediaRequest(idx) {
			if (typeof idx === 'number') {
				return ((Math.floor(this.mediaRequest(idx) / 10000)) * this.bill[idx].billingBandwith.AWSPricePer10_000Requests).toFixed(2)
			} else {
				return ((Math.floor(this.mediaRequest(idx) / 10000)) * idx.billingBandwith.AWSPricePer10_000Requests).toFixed(2)
			}
		},
		//total price storage
		totalBillingStorage(idx) {
			if (typeof idx === 'number') {
				return this.bill[idx].billingStorage !== undefined ? ((this.bill[idx].billingStorage.thumbnailFilesGB + this.bill[idx].billingStorage.transcodedFilesGB + this.bill[idx].billingStorage.uploadedFilesGB) * this.priceStorageGB).toFixed(2) : 0
			} else {
				return idx.billingStorage !== undefined ? ((idx.billingStorage.thumbnailFilesGB + idx.billingStorage.transcodedFilesGB + idx.billingStorage.uploadedFilesGB) * this.priceStorageGB).toFixed(2) : 0

			}
		},
		//TOTAL 
		calculateTotal(idx) {
			return (parseFloat(this.calculateBandwidthTotal(idx)) + parseFloat(this.mediaConvertTotal(idx)) + parseFloat(this.totalMediaRequest(idx)) + parseFloat(this.totalBillingStorage(idx)))
		},
		// TOTAL + % user
		totalReceivable10(idx, perc) {
			return ((this.calculateTotal(idx)) + ((perc / 100)) * this.calculateTotal(idx)).toFixed(2)
		}
	},
};
</script>

<style lang="scss" scoped>
.search-form {
	margin-top: 20px;
	width: 100%;
	display: flex;
}

.description {
	display: block;
}

.titleName {
	display: flex;
	justify-content: center;
	font-size: 24px;
	margin: 15px 0;
	font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.accountContainer {
	border-radius: 6px;
	box-shadow: 0 3px 10px rgba(0, 0, 0, 0.2);
	margin: 20px 0;
	padding: 15px 0;
}

.info {
	margin: 0 4px;
	display: flex;
	justify-content: space-evenly;
}

.request {
	height: 100px;
	background-color: aquamarine;
}

.editPercentage {
	display: flex;
	justify-content: center;

	.editIcon {
		margin-left: 10px;
		font-size: 18px;
		color: rgb(156, 155, 155) !important;
		transition: all 0.1s ease-in-out;
	}

	.editIcon:hover {
		font-size: 25px;
		cursor: pointer;

	}

	.editBtn {
		width: 25px;
		height: 25px;
		border: none;
		background-color: transparent;
	}
}

.priceTotal {
	border-radius: 4px;
	margin: auto;
	padding: 0 10px;
	width: fit-content;
	color: #fff;
	background-color: #4292afc3;
}

.priceTotal.priceFinal {
	background-color: #bc1f4a;
}

.totalFinal {
	font-weight: 600 !important;
}

.content-table {
	width: 100%;
	margin-top: 20px !important;
	padding-left: 10px;
	padding-right: 10px;
	margin: auto;
}

#no-results {
	display: flex;
	padding: 20px;

	.md-icon {
		margin-right: 5px;
	}

	.message {
		margin: auto;
	}
}

.styleRow {
	align-items: self-end;

	p {
		font-weight: 400;
	}
}

.rowElements {
	flex: 1;
	padding: 6px 32px 6px 24px;
}

.colorHover:hover {
	background-color: #eee;
}


.titleLine {
	padding: 10px;
	border-bottom: 1 px solid rgba(153, 155, 155, 0.486);
}</style>



// WEBPACK FOOTER //
// src/shared-components/report/NewBilling.vue